<div class="wrapper flex justify-center">
    <mat-card appearance="outlined" class="w-full sm:w-3/4 md:w-1/2 lg:w-1/3 pt-3 mt-5 mx-4 sm:mx-0">
        <mat-card-header class="flex flex-col items-center w-full">
            <div class="text-center mb-10 font-bold text-2xl md:text-3xl">
                Prendre un rendez-vous
            </div>
            <div class="flex flex-col items-center h-auto w-full p-2 mb-5">
                <img class="w-24 h-24 md:w-32 md:h-32 opacity-14 object-contain" [src]="branding.imageUrl"
                    alt="logo" />
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="px-4 md:px-8 mx-auto max-w-2xl">
                <form [formGroup]="appointmentForm">
                    <div class="flex space-x-4 mt-1">
                        <mat-form-field class="fuse-mat-dense flex-auto">
                            <mat-label>Prénom</mat-label>
                            <input matInput [formControlName]="'firstName'" [placeholder]="'Prénom'">
                        </mat-form-field>
                    </div>
                    <div class="flex space-x-4 mt-1">
                        <mat-form-field class="fuse-mat-dense flex-auto">
                            <mat-label>Nom</mat-label>
                            <input matInput [formControlName]="'lastName'" [placeholder]="'Nom'">
                        </mat-form-field>
                    </div>
                    <div class="flex space-x-4 mt-1">
                        <mat-form-field class="fuse-mat-dense flex-auto">
                            <mat-label>Téléphone</mat-label>
                            <input matInput [formControlName]="'phone'" [placeholder]="'Téléphone'">
                        </mat-form-field>
                    </div>
                    <div class="flex space-x-4 mt-1">
                        <mat-form-field class="fuse-mat-dense flex-auto">
                            <mat-label>Médecin</mat-label>
                            <input type="text" placeholder="Médecin" aria-label="Médecin" matInput
                                [formControl]="inputDoctor" [matAutocomplete]="autoDoctor">
                            <mat-autocomplete #autoDoctor="matAutocomplete" [displayWith]="displayUser">
                                @for (d of (doctorOptions$ | async) || []; track d.id) {
                                <mat-option [value]="d">{{d.lastName}} {{d.firstName}}</mat-option>
                                }
                            </mat-autocomplete>
                            <mat-icon class="icon-size-5" matSuffix [svgIcon]="'heroicons_solid:user'"></mat-icon>
                        </mat-form-field>
                        <button mat-icon-button type="button" [color]="noDoctorPreference ? 'warn' : 'primary'"
                            (click)="toggleDoctorPreference()"
                            [matTooltip]="noDoctorPreference ? 'Cliquez pour choisir un médecin' : 'Pas de préférence de médecin'"
                            class="mt-2">
                            <mat-icon>{{ noDoctorPreference ? 'person_off' : 'person_remove' }}</mat-icon>
                        </button>
                    </div>
                    @if (noDoctorPreference) {
                    <div class="text-sm text-orange-600 -mt-3 mb-2 ml-1">
                        Aucune préférence de médecin
                    </div>
                    }
                    <div class="flex space-x-4 mt-1">
                        <mat-form-field class="fuse-mat-dense flex-auto">
                            <mat-label>Motif de consultation</mat-label>
                            <textarea matInput [formControlName]="'motif'"
                                [placeholder]="'Décrivez brièvement le motif de votre consultation'"
                                rows="3"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 mt-1">
                        <div class="w-full md:w-1/2">
                            <mat-form-field class="fuse-mat-dense flex-auto w-full">
                                <mat-label>Choisir une date</mat-label>
                                <input matInput [formControl]="dateInput" [matDatepicker]="picker" inputmode="numeric"
                                    [matDatepickerFilter]="dateFilter" [min]="minDate" placeholder="DD/MM/YYYY">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="w-full md:w-1/2">
                            <mat-form-field class="w-full compact-form-field">
                                <mat-label>Choisir une heure</mat-label>
                                <mat-select [formControlName]="'time'">
                                    @for(time of dayTimes; track time) {
                                    <mat-option [disabled]="isTimeDisabled(time)" [value]="time">
                                        {{ time }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="flex space-x-4 mt-1 ml-5">
                        @if (successMessage) {
                        <fuse-alert [type]="'success'">
                            <span fuseAlertTitle>Rendez-vous pris</span>
                            Votre rendez-vous va être traité par l'accueil, et vous allez être recontacté
                        </fuse-alert>
                        }
                        @else if(errorMessage) {
                        <fuse-alert [type]="'error'">
                            <span fuseAlertTitle>Erreur création rendez-vous</span>
                            Veuillez réessayer de prendre un rendez-vous
                        </fuse-alert>
                        }
                        @else {
                        <button mat-flat-button [color]="'primary'" class="justify-center" style=""
                            [disabled]="appointmentForm.invalid || (!noDoctorPreference && !inputDoctor.value)"
                            (click)="sendAppointmentRequest()">Prendre rendez-vous</button>
                        }
                    </div>
                </form>
            </div>
        </mat-card-content>
    </mat-card>
</div>